/**
 * Scroll Reveal Utility
 * Утилита для анимаций при скролле в стиле Vertex
 * Автор: AI Market Hub
 */

/**
 * Инициализирует Intersection Observer для анимаций при скролле
 */
export function initScrollReveal() {
  if (typeof window === 'undefined') return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          // Можно добавить одноразовое наблюдение
          // observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }
  );

  // Наблюдаем за всеми элементами с классом animate-on-scroll
  document.querySelectorAll('.animate-on-scroll').forEach((el) => {
    observer.observe(el);
  });

  return observer;
}

/**
 * Инициализирует эффект раскрытия цитат при скролле
 */
export function initQuoteReveal() {
  if (typeof window === 'undefined') return;

  const section = document.querySelector('.quoteRevealSection');
  if (!section) return;

  const target = section.querySelector('.quoteReveal');
  const words = section.querySelectorAll('.quote-word');
  
  if (!target || words.length === 0) return;

  // Инициализируем все слова как затемненные
  words.forEach((word) => {
    word.style.color = 'rgb(64 64 64)'; // neutral-700
  });

  function updateWordReveal() {
    const rect = target.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const scrollProgress = Math.max(0, Math.min(1, (vh - rect.top) / (vh * 0.5)));
    const wordsToReveal = Math.floor(scrollProgress * words.length);

    words.forEach((word, index) => {
      if (index < wordsToReveal) {
        word.style.color = 'rgb(255 255 255)';
      } else {
        word.style.color = 'rgb(64 64 64)';
      }
    });
  }

  window.addEventListener('scroll', updateWordReveal, { passive: true });
  window.addEventListener('resize', updateWordReveal);
  updateWordReveal();
}

/**
 * Инициализирует все эффекты скролла
 */
export function initAllScrollEffects() {
  if (typeof window === 'undefined') return;

  // Ждем загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initScrollReveal();
      initQuoteReveal();
    });
  } else {
    initScrollReveal();
    initQuoteReveal();
  }
}



